<template>
    <div class="new-member-form-header">
            <div class="middle-container">
              <div class="row">
                <div class="col-xs-12">
                  <h1>{{ d.headertitle }} </h1>
                <p class="manchet">{{ getHeaderText() }}</p>
                <div class="form-summary">
                   <div class="row">
                    <!-- DISABLED FOR NOW - STO / 2024-03-06 -->
                    <!-- <div class="col-xs-12 col-md-6"> -->
                    <div class="col-xs-12">
                      <p class="situation">{{d.productName}}</p>
                      <div class="product-summary">
                        <div class="union">
                          <div>
                            <div>{{ d.union }}</div>
                            <p v-if="product.subscriptiontype === 'student'" class="promotion-detail">
                              {{ d.studentpricepromotionaldetail }}
                            </p>
                          </div>
                          <div>
                            <span class="pricetag" data-unionprice>
                              {{ product.priceunion == 0.0 ? d.free : product.priceunion  }}
                            </span>
                            <span v-bind:class="{ 'hidden': product.priceunion == 0.0}" class="suffix" data-unionsuffix>{{ d.productpricesuffix }}</span>
                          </div>
                        </div>
                        <div class="unemployment-insurance">
                          <div>
                            <label class="check-after-input checkbox" for="unemploymentinsurance">
                              <input type="checkbox" id="unemploymentinsurance" v-model="product.unemploymentinsuranceselected" @change="emitter.emit('insurance-change', product.unemploymentinsuranceselected);" />
                              <span class="checklabel">{{ d.unemploymentinsurance }}</span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div>
                            <span v-bind:class="{ 'inactive' : !product.unemploymentinsuranceselected}" class="pricetag" data-unemploymentprice>
                              {{ product.priceunemployment == 0.0 ? d.free : product.priceunemployment }}
                            </span>
                            <span v-bind:class="{ 'hidden': product.priceunemployment == 0.0 }" class="suffix" data-unemploymentsuffix>{{ d.productpricesuffix }}</span>
                        </div>
                          </div>
                        <div class="product-total">
                          <div class="total">Total</div>
                          <div>
                            <span class="pricetag" data-totalprice>
                              {{ calculateTotalPrice }}
                            </span>
                            <span v-bind:class="{ 'hidden': calculateTotalPrice == d.free}" class="suffix" data-totalsuffix>{{ d.productpricesuffix }}</span>
                          </div>
                      </div>
                      </div>
                      
                        
                    </div>
                    <!-- DISABLED FOR NOW - STO / 2024-03-06 -->
                    <!--
                    <div class="col-xs-12 col-md-6 flex">
                      <div class="campaign-container" v-show="!product.promocodeused">
                        <CampaignInput></CampaignInput>
                      </div>
                      <div v-show="product.promocodeused">
                        <p class="promo-code-used-title">{{ d.promocodeusedtitle }}</p>
                        <p>{{ product.campaignText }}</p>
                      </div>
                    </div>
                    -->
                    </div>
                   </div>
                </div>
              </div>
                </div>
            </div>

    <!-- RECRUITER SETTINGS -->
    <section v-if="d.showRecruiters" class="member-signup custom-margin">

      <div class="new-member-form-header">
        <div class="middle-container">
          <div class="row">
            <div class="col-xs-12">
              <RecruiterList :recruiters="d.recruiters"></RecruiterList>
            </div>
          </div>
        </div>
      </div>

    </section>
    <!-- RECRUITER SETTINGS -->
</template>
<script>
import useVuelidate from '@vuelidate/core';
import RecruiterList from "../FormComponents/RecruiterList.vue";
import axios from 'axios';
// DISABLED FOR NOW - STO / 2024-03-06
// import CampaignInput from '../FormComponents/CampaignInput.vue';
export default {
    components: {
      RecruiterList,
    },
    setup() {
        return { v$: useVuelidate() };
    },
    data: (instance) => {
      return {
        values: instance.store[instance.store.currentCulture].values.personalDetails,
        product: instance.store[instance.store.currentCulture].values.productDetails,
        d: instance.store[instance.store.currentCulture].dictionary,
        culture: instance.store.currentCulture,
        promoCodeError: false,
        monthsOfFreeUnion: 0.0,
      };
    },
    computed: {
        calculateTotalPrice: function () {
            let total = this.product.priceunion;
            if (this.product.unemploymentinsuranceselected) {
                total += this.product.priceunemployment;
            }
            return total === 0.0 ? this.d.free : total;
        }
    },
    mounted() {
      this.emitter.on('culture-change', () => {
        this.values = this.store[this.store.currentCulture].values.personalDetails;
        this.product = this.store[this.store.currentCulture].values.productDetails;
        this.d = this.store[this.store.currentCulture].dictionary;
        this.culture = this.store.currentCulture;

        this.v$.$reset()
      });
    },
    methods: {
        async submitPromoCode() {
          let updatePriceList = null;
          try {
            updatePriceList = await axios.get(`/umbraco/api/signup/GetPrice?segment=${this.product.subscriptiontype}&campaignCode=${this.product.promocode}&culture=${this.culture}`);
          }
          catch (error) {
            console.log(error);
          }
          const priceList = updatePriceList?.data;
          if (!priceList || priceList.Campaign === null) {
            this.product.promocodeused = false;
            this.promoCodeError = true;
          }
          else {
            this.promoCodeError = false;
            this.product.promocodeused = true;
            this.product.priceunion = priceList.Campaign.priceUnion;
            this.product.priceunemployment = priceList.Campaign.priceUnemployment;
            this.product.campaignText = priceList.Campaign.campaignText;
          }
        },
        getHeaderText(){
          //
          switch (this.product.subscriptiontype) {
            case 'employed':
              return this.d.headermanchet;

            case 'student':
              return this.d.headermanchetstudent;

            case 'unemployed':
              return this.d.headermanchetunemployed;

            default:
              console.log(`No product`);
          }
        },
        changePromoErrorState() {
            this.promoCodeError = false;
            if (this.product.promocode.length) {
                document.getElementById("submitPromoCode").disabled = false;
            }
            else {
                document.getElementById("submitPromoCode").disabled = true;
            }
        }
    },
            

    // components: { CampaignInput }
}
</script>
<style scoped lang="postcss">
.middle-container {
  padding: 20px;
}
.new-member-form-header {
  background: var(--color-green);
  padding: var(--grid-gutter-3) 0 var(--grid-gutter-2) 0;
  font-family: var(--font-it-md);

  .promotion-detail {
    font-family: var(--font-it-md);
    font-size: var(--font-size-xxs);
    margin-bottom: 4px;
    font-weight: 400;

    @media screen and (min-width: 1024px) {
    font-size: var(--font-size-xs);
    }
  }

  p.manchet {
    font-size: 22px;
    font-family: var(--font-it-md);
  }

  .form-summary {
    background: var(--color-white);
    padding: 15px 20px 15px 20px;

    p.situation, .pricetag {
      font-family: var(--font-it-md);
      font-weight: var(--font-weight-demibold);
      font-size: 24px;
      
      margin-bottom: 0;
    }

    .pricetag {
      font-weight: var(--font-weight-regular);
    }
    

    p.promo-code-used-title {
      margin-top: 20px;
      font-weight: var(--font-weight-demibold);
    }

    .product-summary {
      .union{
        font-family: var(--font-it-ex);
        font-weight: var(--font-weight-regular);
        letter-spacing: var(--letter-spacing);
      }
      .union, .unemployment-insurance, .product-total {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &.unemployment-insurance {
          margin-bottom: 8px;

          label {
            margin-bottom: 0;
          }
        }
        &.product-total {
          font-family: var(--font-it-ex);
          letter-spacing: var(--letter-spacing);

          padding-top: 8px;
          border-top: 1px solid rgba(0, 25, 101, .3);
          
          .pricetag {
            color: var(--color-blue);
            font-weight: var(--font-weight-regular);
          }

          .total {
            font-weight: var(--font-weight-bold);
          }
        }
      }
      .suffix {
        font-family: var(--font-it-ex);
        font-weight: var(--font-weight-regular);
        letter-spacing: var(--letter-spacing);
        margin-left: 8px;
      }
    }
    
    .campaign-container {
      display: flex;
      height: 100%;
      padding-top: 10px;
      @media screen and (min-width:1024px) {
        padding-top: 0;
      }
    }
  }

  .inactive, button:disabled  {
    opacity: 0.3;
  }
  .flex {
    position: relative;
  }
  .hidden {
    display: none;
  }
}
</style>